module.exports = __webpack_public_path__ + "img/huiyi.fa9ed5f3.png";